import { useState, useEffect } from 'react'
import {
  Box, Card, CardContent, Typography, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, Paper, IconButton, Chip,
  CircularProgress,
} from '@mui/material'
import { Download, Delete, Visibility } from '@mui/icons-material'
import { reportApi } from '../services/api'

const ReportsPage = () => {
  const [reports, setReports] = useState<any[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => { fetchReports() }, [])

  const fetchReports = async () => {
    try {
      const res = await reportApi.getReports()
      setReports(res.data.reports || res.data || [])
    } catch (e) {
      console.error('Failed to fetch reports:', e)
    } finally {
      setLoading(false)
    }
  }

  const handleDownload = async (id: string, title: string) => {
    try {
      const res = await reportApi.downloadReport(id)
      const url = window.URL.createObjectURL(new Blob([res.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `${title || 'report'}.html`)
      document.body.appendChild(link)
      link.click()
      link.remove()
    } catch (e) {
      console.error('Download failed:', e)
    }
  }

  const handleDelete = async (id: string) => {
    try {
      await reportApi.deleteReport(id)
      fetchReports()
    } catch (e) {
      console.error('Delete failed:', e)
    }
  }

  if (loading) return <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}><CircularProgress /></Box>

  return (
    <Box>
      <Typography variant="h4" sx={{ mb: 3 }}>Reports</Typography>
      <Card>
        <CardContent>
          {reports.length === 0 ? (
            <Box sx={{ textAlign: 'center', py: 4 }}>
              <Typography variant="h6" color="text.secondary">No reports yet</Typography>
              <Typography variant="body2" color="text.secondary">
                Generate a report from an analysis to see it here
              </Typography>
            </Box>
          ) : (
            <TableContainer component={Paper} variant="outlined">
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Title</TableCell>
                    <TableCell>Format</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell>Created</TableCell>
                    <TableCell>Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {reports.map((r: any) => (
                    <TableRow key={r.id} hover>
                      <TableCell>{r.title || r.id?.substring(0, 12)}</TableCell>
                      <TableCell><Chip label={r.format || 'HTML'} size="small" /></TableCell>
                      <TableCell>
                        <Chip
                          label={r.status || 'completed'}
                          color={r.status === 'completed' ? 'success' : 'warning'}
                          size="small"
                        />
                      </TableCell>
                      <TableCell>{new Date(r.created_at).toLocaleString()}</TableCell>
                      <TableCell>
                        <IconButton size="small" onClick={() => handleDownload(r.id, r.title)}>
                          <Download />
                        </IconButton>
                        <IconButton size="small" onClick={() => handleDelete(r.id)}>
                          <Delete />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </CardContent>
      </Card>
    </Box>
  )
}

export default ReportsPage
